import styled from 'styled-components';
import variables, { mq, fs, screenSize, isTouchMedia } from '../../utils/variables';

export const Button = styled.a`
  position: relative;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  padding: 0;
  color: ${variables.colors.white};
  font-family: 'Bossa', sans-serif;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0px 9px 90px rgba(7, 13, 28, 0.25);

  ${fs(16)}

  ${screenSize('height', 62)}
  ${screenSize('line-height', 60)}
  ${screenSize('border-radius', 62)}
  ${screenSize('padding-left', 35)}
  ${screenSize('padding-right', 35)}

  &.large {
    ${screenSize('min-width', 268)}
  }

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background: ${variables.colors.blue};
    transition: all .2s ease-in-out;
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: ${variables.colors.red};
    transition: all .2s ease-in-out;
  }

  ${mq('m')} {
    height: 60px;
    padding: 0 34px;
    font-size: 15px;
    line-height: 58px;
    border-radius: 28px;
  }

  ${isTouchMedia()} {
    &:hover {
      /* color: ${variables.colors.red}; */
      /* background-color: ${variables.colors.white}; */
      /* border-color: ${props => props.dark ? variables.colors.blue : variables.colors.red}; */

      &::before {
        width: 100%;
      }

      &::after {
        width: 0;
      }
    }
  }

  &.ghost {
    color: ${variables.colors.red};
    background-color: ${variables.colors.white};
    border-color: ${props => props.dark ? variables.colors.white : variables.colors.red};

    &::after {
      background-color: ${variables.colors.white};
    }

    ${isTouchMedia()} {
      &:hover {
        color: ${variables.colors.white};
        background-color: ${variables.colors.red};
        border-color: ${props => props.dark ? variables.colors.white : variables.colors.red}
      }
    }
  }

  &.reverse {
    background-color: ${variables.colors.white};
    color: ${variables.colors.blue};
    border-color: ${variables.colors.white};

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      background: ${variables.colors.red};
      transition: all .2s ease-in-out;
    }
  
    &::after {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: ${variables.colors.white};
      transition: all .2s ease-in-out;
    }

    ${isTouchMedia()} {
      &:hover {
        color: ${variables.colors.white};

        &::before {
          width: 100%;
        }
  
        &::after {
          width: 0;
        }
      }
    }
  }
`;